import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { PriceMaximizerInput } from '../../@types/price-maximizer-types'
import { getDefaultLogger } from '../../services/logger/logger'
import { getRealEstateType } from './converters/realEstateType'

export const getSavedSearches = async (realEstateData: PriceMaximizerInput): Promise<number | undefined> => {
  const body = {
    realEstateType: getRealEstateType(realEstateData.category, realEstateData.transaction),
    location: {
      lat: realEstateData.geoCoordinates.latitude,
      lon: realEstateData.geoCoordinates.longitude,
    },
    livingArea: realEstateData.livingSpace,
    price: realEstateData.price,
    rooms: realEstateData.noRooms,
    groundArea: realEstateData.plotArea,
  }

  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
    body: JSON.stringify(body),
  }

  const response = await customFetch(
    `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/pricemaximizer/savedsearches`,
    options
  )
  if (response.status == 200) {
    return (await response.json()) as number
  }

  getDefaultLogger().warn('Failed to load saved searches from PriceMaximizer API (fallback available)', response)
  return undefined
}

export const getSimilarObjects = async (realEstateData: PriceMaximizerInput): Promise<number | undefined> => {
  const parameters = new URLSearchParams()
  parameters.append('latitude', realEstateData.geoCoordinates.latitude.toString())
  parameters.append('longitude', realEstateData.geoCoordinates.longitude.toString())
  parameters.append('livingSpace', realEstateData.livingSpace)
  parameters.append('numberOfRooms', realEstateData.noRooms)
  parameters.append('price', realEstateData.price.toString())
  realEstateData.plotArea && parameters.append('plotArea', realEstateData.plotArea)

  const options = {
    method: 'GET',
    headers: {
      Accept: 'application/json; charset=utf-8',
    },
    credentials: 'include',
  }

  const response = await customFetch(
    `${API_ENDPOINT}/anbieten/private-anbieter/inserieren/api/pricemaximizer/similarobjects/realEstateType/${getRealEstateType(
      realEstateData.category,
      realEstateData.transaction
    )}\?${parameters.toString()}`,
    options
  )
  if (response.status == 200) {
    return (await response.json()).paging.numberOfHits as number
  }

  getDefaultLogger().warn('Failed to load similar objects from PriceMaximizer API (fallback available)', response)
  return undefined
}
